import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';

export default class ActionsIndexRoute extends Route {
  beforeModel(transition: Transition) {
    super.beforeModel(transition);
    this.router.transitionTo('workspace-settings');
  }
}
